import "../../../styles/global.css"
import styles from "../../../styles/Login.module.css"

import { useState, useEffect, MouseEvent } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useTheme, Theme } from "@mui/material/styles"
import { Box, CssBaseline, ThemeProvider } from "@mui/material"

import { deleteTokenLocal } from "../../../helper/utils"
import { setUserLogIn } from "../../redux/slices/appSlice"

import { toast } from "react-toastify"

import { customTheme } from "./Atom"

import NavAppBar from "./NavAppBar"
import NavDrawer from "./NavDrawer"

type SidebarStateProps = {
  dashboard: boolean
  metric: boolean
  users: boolean
  customer: boolean
  metricGoal: boolean
  metricOpportunity: boolean
  opportunityDashboard: boolean
  resourceBudget: boolean
  pnlBudget: boolean
  pnlReporting: boolean
  providers: boolean
  officeHuddle: boolean
  audit: boolean
  compliance: boolean
  productionSummary: boolean
  helpCenter: boolean
  officeHours: boolean
  doctorCompensation: boolean
  prontoAi: boolean
}

const intialSidebarItemsState: SidebarStateProps = {
  dashboard: false,
  metric: false,
  users: false,
  customer: false,
  metricGoal: false,
  metricOpportunity: false,
  opportunityDashboard: false,
  resourceBudget: false,
  pnlBudget: false,
  pnlReporting: false,
  providers: false,
  officeHuddle: false,
  audit: false,
  compliance: false,
  productionSummary: false,
  helpCenter: false,
  officeHours: false,
  doctorCompensation: false,
  prontoAi: false,
}

export default function Navbar(props: any) {
  const { handleDrawerClose, handleDrawerOpen, open } = props

  const location = useLocation()
  const theme = useTheme()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const adminData = useSelector((state: any) => {
    return state.admin
  })

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [isSelected, setIsSelected] = useState<any>(intialSidebarItemsState)

  const opener = Boolean(anchorEl)

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClickMyAccount = () => {
    navigate("/my-profile")
  }

  const handleLogout = () => {
    deleteTokenLocal()
    dispatch({ type: "RESET" }) //calls the root reducer with RESET as action!
    dispatch(setUserLogIn(false))
    toast.success("Logged out successfully")
    navigate("/auth")
  }

  useEffect(() => {
    if (location.pathname == "/") {
      setIsSelected({ ...intialSidebarItemsState, dashboard: true })
    }
    if (location.pathname == "/huddle") {
      setIsSelected({ ...intialSidebarItemsState, officeHuddle: true })
    }
    if (location.pathname == "/metric-bm") {
      setIsSelected({ ...intialSidebarItemsState, metric: true })
    }
    if (location.pathname == "/users") {
      setIsSelected({ ...intialSidebarItemsState, users: true })
    }
    if (location.pathname == "/customer") {
      setIsSelected({ ...intialSidebarItemsState, customer: true })
    }
    if (location.pathname == "/group-profile") {
      setIsSelected({ ...intialSidebarItemsState, customer: true })
    }
    if (location.pathname == "/metric-g") {
      setIsSelected({ ...intialSidebarItemsState, metricGoal: true })
    }
    if (location.pathname == "/metric-o") {
      setIsSelected({ ...intialSidebarItemsState, metricOpportunity: true })
    }
    if (location.pathname == "/opportunity-dashboard") {
      setIsSelected({ ...intialSidebarItemsState, opportunityDashboard: true })
    }
    if (location.pathname == "/resource-budget") {
      setIsSelected({ ...intialSidebarItemsState, resourceBudget: true })
    }
    if (location.pathname == "/p-and-l-budget") {
      setIsSelected({ ...intialSidebarItemsState, pnlBudget: true })
    }
    if (location.pathname == "/p-and-l-reporting") {
      setIsSelected({ ...intialSidebarItemsState, pnlReporting: true })
    }
    if (location.pathname == "/providers") {
      setIsSelected({ ...intialSidebarItemsState, providers: true })
    }
    if (location.pathname == "/audit") {
      setIsSelected({ ...intialSidebarItemsState, audit: true })
    }
    if (location.pathname == "/compliance") {
      setIsSelected({ ...intialSidebarItemsState, compliance: true })
    }
    if (location.pathname == "/production-summary") {
      setIsSelected({ ...intialSidebarItemsState, productionSummary: true })
    }
    if (location.pathname == "/help-center") {
      setIsSelected({ ...intialSidebarItemsState, helpCenter: true })
    }
    if (location.pathname == "/office-hours") {
      setIsSelected({ ...intialSidebarItemsState, officeHours: true })
    }
    if (location.pathname == "/doctor-compensation") {
      setIsSelected({ ...intialSidebarItemsState, doctorCompensation: true })
    }
    if (location.pathname == "/pronto-ai") {
      setIsSelected({ ...intialSidebarItemsState, prontoAi: true })
    }
  }, [location])
  return (
    <>
      <ThemeProvider theme={customTheme}>
        <Box sx={{ display: "flex", height: "10vh" }}>
          <CssBaseline />
          <NavAppBar
            open={open}
            handleDrawerOpen={handleDrawerOpen}
            adminData={adminData}
            anchorEl={anchorEl}
            handleClick={handleClick}
            handleClose={handleClose}
            handleClickMyAccount={handleClickMyAccount}
            handleLogout={handleLogout}
            opener={opener}
          />
          <NavDrawer
            open={open}
            styles={styles}
            theme={theme}
            handleDrawerOpen={handleDrawerOpen}
            isSelected={isSelected}
            handleDrawerClose={handleDrawerClose}
          />
        </Box>
      </ThemeProvider>
    </>
  )
}
